import React, { ComponentPropsWithRef, type ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

import { Slot, type AsChildProps } from '@/stories/atoms/Slot/Slot';
import styles from './button.module.css';

export type ButtonProps = React.PropsWithChildren  & ComponentPropsWithRef<'button'> & {
  /** Is this the principal call to action on the page? */
  variant?: 'primary' | 'secondary' | 'default' | 'ideeri-primary' | 'ideeri-secondary' | 'ideeri-light' | 'ideeri-dark';
  /** What's the size? */
  size?: 'small' | 'normal';
  /** Is the button rounded on desktop ? */
  rounded?: boolean,
  /** Is button is in active state (no possible hover) */
  active?: boolean,
  className?: string
}

export type Props = AsChildProps<
  ButtonProps,
  ButtonHTMLAttributes<HTMLButtonElement>
>

/** Primary UI component for user interaction */
export const Button = ({
  variant = 'primary',
  size = 'normal',
  active,
  rounded,
  children,
  className,
  asChild,
  ...props
}: Props) => {
  const Component = asChild ? Slot : "button";

  return (
    <Component
      className={clsx(styles.button, variant && styles[variant], styles[size], rounded && styles.rounded, active && styles.active, className)}
      {...props}>
      {children}
    </Component>
  );
};
